import React from "react";
import styled from "styled-components";

const Button = styled.button`
  background: white;
  border: 1px solid #605dec;
  color: #605dec;
  height: 48px;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.25px;
  cursor: pointer;
  white-space: nowrap;
  &:hover:not(:disabled) { background: #f4f4fd; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const PlusCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M8 12H16M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#605DEC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Isolated "Assign New Lesson" CTA (outlined circle-plus icon + label).
export const AssignNewLessonButton = ({ onClick, disabled = false, children = "Assign New Lesson", ...rest }) => (
  <Button type="button" onClick={onClick} disabled={disabled} {...rest}>
    <PlusCircleIcon />
    {children}
  </Button>
);
